import type { JSX } from 'react'

import { SettingsPageContainerSC } from './SettingsPageContainer.styled'

export interface ISettingsPageContainerProps {
  children?: React.ReactNode
  maxWidth?: number
}

export const SettingsPageContainer = ({
  // TODO back here
  children,
  maxWidth,
}: ISettingsPageContainerProps): JSX.Element => {
  return (
    <SettingsPageContainerSC maxWidth={maxWidth}>
      {children}
    </SettingsPageContainerSC>
  )
}
